<template>
    <div class="block sm:ml-24 max-w-7xl text-center border border-sepBorder rounded-lg h-full mt-2 py-5 pb-36 overflow-auto dark:text-dark.textOnBkg dark:border-dark.sepBorder">
        <!-- Back to Add-ons -->
        <div class="flex justify-start mb-4">
            <router-link to="/addons" class="flex items-center text-blue-500 hover:underline">
                <font-awesome-icon :icon="['fas', 'arrow-left']" class="mr-2" />
                Back to Add-ons
            </router-link>
        </div>
        
        <!-- Creator Header -->
        <div class="bg-white dark:bg-dark.card shadow rounded-lg p-4 mb-6">
            <div class="flex items-center space-x-4">
                <MazAvatar :src="creator.picture" size="3rem" />
                <div>
                    <h1 class="text-2xl font-bold">{{ creator.name }}</h1>
                    <p class="text-gray-600 dark:text-gray-400">
                        Fans: {{ creator.fansCount }} | Earnings: ${{ creator.earnings }}
                    </p>
                </div>
            </div>
        </div>
        
        <!-- Add-ons List -->
        <div class="space-y-4">
            <div v-for="addon in activeAddons" :key="addon.name" class="bg-white dark:bg-dark.card shadow rounded-lg overflow-hidden" >
                <div class="p-4 flex justify-between items-center cursor-pointer" @click="toggleAddon(addon.name)" >
                    <h2 class="text-xl font-semibold">{{ addon.label }} ({{ addon.price }}/day)</h2>
                    <font-awesome-icon :icon="expanded[addon.name] ? 'chevron-up' : 'chevron-down'" />
                </div>
                <div v-if="expanded[addon.name]" class="p-4 border-t">
                    <MazSwitch v-model="creator.addons[addon.name]" :label="`Enable ${addon.label}`" class="mb-4" />
                    <h3 class="text-lg font-medium mb-2">Logs</h3>
                    <div class="max-h-64 overflow-y-auto">
                        <table class="w-full text-left">
                            <thead>
                                <tr class="bg-gray-100 dark:bg-gray-700">
                                    <th class="p-2">Action</th>
                                    <th class="p-2">Details</th>
                                    <th class="p-2">Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="log in addon.logs" :key="log.id" class="border-t">
                                    <td class="p-2">{{ log.action }}</td>
                                    <td class="p-2">{{ log.details }}</td>
                                    <td class="p-2">{{ log.time }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h3 class="text-lg font-medium mt-4 mb-2">Settings</h3>
                    <label class="block mb-2">
                        <input type="checkbox" v-model="addon.settings.agencyOnly" />
                        Share only within agency
                    </label>
                    <div>Exclude Accounts:</div>
                    <label v-for="acc in addon.availableAccounts" :key="acc" class="block">
                        <input type="checkbox" v-model="addon.settings.excluded" :value="acc" />
                        {{ acc }}
                    </label>
                </div>
            </div>
    
            <!-- Add More Add-ons -->
            <div class="bg-white dark:bg-dark.card shadow rounded-lg p-4">
                <h2 class="text-xl font-semibold mb-4">Add More Power-Ups</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div v-for="addon in availableAddons" :key="addon.name" class="p-2 border rounded hover:bg-gray-50 dark:hover:bg-gray-700" >
                        <MazSwitch v-model="creator.addons[addon.name]" :label="`${addon.label} (${addon.price}/day)`" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
export default {
    name: 'AddOnsManage',
    data() {
        return {
            creatorId: this.$route.params.creatorId,
            creator: {
                name: 'Jane Doe',
                picture: 'https://via.placeholder.com/48',
                fansCount: 1200,
                earnings: 4500,
                addons: { reposting: true, followExpired: false, likes: false },
            },
            expanded: {},
            addonConfigs: {
                reposting: {
                    label: 'Automated Reposting',
                    price: '0.5€',
                    logs: [
                    { id: 1, action: 'Reposted', details: 'Post X to @AccountY', time: '2023-10-01 14:00' },
                    ],
                    settings: { agencyOnly: false, excluded: [] },
                    availableAccounts: ['@AccountY', '@AccountZ'],
                },
                followExpired: { label: 'Follow Expired Fans', price: '0.5€', logs: [], settings: { agencyOnly: false, excluded: [] }, availableAccounts: [] },
                likes: { label: 'Likes for Likes', price: '0.5€', logs: [], settings: { agencyOnly: false, excluded: [] }, availableAccounts: [] },
            },
        };
    },
    computed: {
        authStore() {
            return useAuthStore();
        },
        myself() {
            return this.authStore.myself;
        },
        permissions() {
            return this.authStore.permissions;
        },
        activeAddons() {
            return Object.keys(this.creator.addons)
            .filter((key) => this.creator.addons[key])
            .map((key) => this.addonConfigs[key]);
        },
        availableAddons() {
            return Object.keys(this.addonConfigs)
            .filter((key) => !this.creator.addons[key])
            .map((key) => this.addonConfigs[key]);
        },
    },
    methods: {
        toggleAddon(addonName) {
            this.$set(this.expanded, addonName, !this.expanded[addonName]);
        },
    },
};
</script>

<style scoped>
/* Add custom Tailwind styles if needed */
</style>
